import {useContext} from 'react'

import PropTypes from 'prop-types'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import MoleculeModal from '@s-ui/react-molecule-modal'
import ModalBasicContent from '@adv-mt/mt-modal-basic-content'
import SpinnerBasic, {spinnerBasicOverlayTypes, spinnerBasicTypes} from '@adv-mt/mt-spinner-basic'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close'

import {PanelFinancingModalContent} from './PanelFinancingModalContent.js'
import {PanelFinancingModalInsuranceInfo} from './PanelFinancingModalInsuranceInfo.js'

// eslint-disable-next-line react/prop-types
export const PanelFinancingModal = ({contentId = '', financingData, onModalClose}) => {
  const {i18n} = useContext(Context)
  const insuranceIdModalInfo = financingData?.calculatorB2cData?.withInsurance?.insuranceId || ''

  const modalContent = {
    legalContent: {
      buttons: {
        confirmButton: {
          customCallBack: () => {
            onModalClose()
          },
          isDisabled: false,
          text: i18n.t('COMMON.UNDERSTOOD')
        }
      },
      children: <PanelFinancingModalContent financingInfo={financingData} handleModal={onModalClose} />
    },
    fdaLoading: {
      children: (
        <div className="mt-PanelFinancing-modalContentFda">
          <SpinnerBasic
            inheritColorText
            overlayType={spinnerBasicOverlayTypes.LIGHT}
            type={spinnerBasicTypes.SECTION}
            text={i18n.t('COMMON.PROCESS_CAN_TAKE_SECONDS')}
          />
        </div>
      )
    },
    fdaError: {
      buttons: {
        confirmButton: {
          customCallBack: () => {
            onModalClose()
          },
          isDisabled: false,
          text: i18n.t('COMMON.UNDERSTOOD')
        }
      },
      children: (
        <div className="mt-PanelFinancing-modalContentFdaError">{i18n.t('PANEL_FINANCING.B2C.ERROR_MODAL_TEXT')}</div>
      )
    },
    fdaInsuranceInfo: {
      buttons: {
        confirmButton: {
          customCallBack: () => {
            onModalClose()
          },
          isDisabled: false,
          text: i18n.t('COMMON.UNDERSTOOD')
        }
      },
      children: <PanelFinancingModalInsuranceInfo insuranceId={insuranceIdModalInfo} />
    }
  }

  return (
    <>
      {contentId !== '' && (
        <MoleculeModal
          isOpen={true}
          closeOnOutsideClick
          closeOnEscKeyDown
          iconClose={<IconClose size={ATOM_ICON_SIZES.medium} />}
          onClose={onModalClose}
        >
          <ModalBasicContent stepsContent={[modalContent[contentId]]} />
        </MoleculeModal>
      )}
    </>
  )
}

PanelFinancingModal.propTypes = {
  contentId: PropTypes.string,
  financingData: PropTypes.object,
  onModalClose: PropTypes.func
}
